const MAXIMUM_AGE = 125;

export { MAXIMUM_AGE };
